import React, {useContext} from 'react';

import api     from '../../../../../api';
import values  from '../../../../../values';
import Context from '../../../../../context';

import AreaScreen     from '..';
import successHandler from '../../../../../utils/successHandler';

import { TModal                   } from '../../../../../types/common.type';
import { locationNamespace        } from '../../../../../types/location.namespace';
import { useQuery, UseQueryResult } from 'react-query';

const CityContainer: React.FC = (): React.ReactElement => {

  const { userInfo } = useContext(Context.UserScreen);

  const getProvince = useQuery(
    ['companyProvince'],
    () => api.get.common.searchProvince({ limit: 50 })
  );

  const provinceFiltered4Company = getProvince?.data?.result && getProvince?.data.result.docs?.filter((item: any) =>
    userInfo?.companyInformation?.province?.includes(item?._id)
  );

  const getCity = useQuery(
    ['companyCities'],
    () => api.get.common.searchCity({limit: 50, province: provinceFiltered4Company[0]?._id}),
    {enabled: provinceFiltered4Company?.length >= 1}
  );

  const cityFiltered4Company = getCity?.data?.result && getCity?.data.result.docs?.filter((item: any) =>
    userInfo?.companyInformation?.city?.includes(item?._id)
  );

  // # =================================================================================================================
  // # --------------------------------------------- Start Validate Values ---------------------------------------------

  const [showModal, setShowModal] = React.useState<TModal>('NONE');
  const [isLoading, setIsLoading] = React.useState<boolean>(false);
  const [selectedArea, setSelectedArea] = React.useState<locationNamespace.area.index | undefined>(undefined);
  const [requestArea , setRequestArea ] = React.useState<locationNamespace.area.request>({
    limit: 10,
    page : 1 ,
  });

  // # ---------------------------------------------- End Validate Values ----------------------------------------------
  // # =================================================================================================================

  // ! =================================================================================================================
  // ! ------------------------------------------------ Start Call API -------------------------------------------------

  const getCities: UseQueryResult<any, unknown> = useQuery(
    [values.useQueryKeys.locationGetArea, requestArea],
    () => api.get.common.searchArea({...requestArea, city: cityFiltered4Company[0]._id}),
    {enabled: cityFiltered4Company?.length >= 1}
  );

  // ! ------------------------------------------------- End Call API --------------------------------------------------
  // ! =================================================================================================================

  // * =================================================================================================================
  // * -------------------------------------------- Start Local Functions ----------------------------------------------

  async function createFunction(event: locationNamespace.area.create): Promise<void> {
    setIsLoading(true);
    const result = await api.post.administrator.createArea(event);
    successHandler(result?.CODE);
    await getCities.refetch();
    setShowModal('NONE');
    setIsLoading(false);
  }

  async function updateFunction(event: locationNamespace.area.update): Promise<void> {
    setIsLoading(true);
    if (!selectedArea) return;
    const result = await api.patch.administrator.updateArea(selectedArea?._id, event);
    successHandler(result?.CODE);
    await getCities.refetch();
    setShowModal('NONE');
    setIsLoading(false);
  }

  // * --------------------------------------------- End Local Functions -----------------------------------------------
  // * =================================================================================================================

  // ? =================================================================================================================
  // ? ----------------------------------------------- Start Return View -----------------------------------------------

  return (
    <Context.Location.Area.Provider value={{
      showModal   ,
      isLoading   ,
      requestArea ,
      selectedArea,
      setShowModal   ,
      createFunction ,
      updateFunction ,
      setRequestArea ,
      setSelectedArea,
    }}>
      <AreaScreen rqData={getCities} />
    </Context.Location.Area.Provider>
  );

  // ? ------------------------------------------------ End Return View ------------------------------------------------
  // ? =================================================================================================================
};

export default CityContainer;
